import { render, staticRenderFns } from "./onInfoAgress.vue?vue&type=template&id=edc52c8e&scoped=true"
import script from "./onInfoAgress.vue?vue&type=script&lang=js"
export * from "./onInfoAgress.vue?vue&type=script&lang=js"
import style0 from "./onInfoAgress.vue?vue&type=style&index=0&id=edc52c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc52c8e",
  null
  
)

export default component.exports